import { ResultFilters } from '../components/filtering/SearchResultFilters';

import { serialiseRange } from './serialiseRange';
import { serialiseSorting } from './serialiseSorting';

export function serializeFilters(filters: ResultFilters) {
  return {
    targetFilter: filters.targetFilter,
    status: filters.status.join(','),
    sorting: serialiseSorting(filters.sorting),
    result: filters.result ? serialiseRange(filters.result) : '',
    reactionCount: filters.reactionCount ? serialiseRange(filters.reactionCount) : '',
    price: filters.price ? serialiseRange(filters.price) : '',
  };
}
